
export default function Activities() {
  const activities = [
    {
      title: 'Kayaking & Canoeing',
      description: 'Paddle through calm waters and explore hidden coves. Rentals available daily from 8 AM to 6 PM.',
      icon: 'ri-sailboat-line',
      color: 'bg-sky-100 text-sky-600',
    },
    {
      title: 'Fishing',
      description: 'Cast your line for bass, trout, and pike. Valid fishing license required. Best spots marked on our map.',
      icon: 'ri-fish-line',
      color: 'bg-teal-100 text-teal-600',
    },
    {
      title: 'Hiking Trails',
      description: 'Discover 15 miles of scenic trails ranging from easy lakeside walks to challenging mountain paths.',
      icon: 'ri-footprint-line',
      color: 'bg-emerald-100 text-emerald-600',
    },
    {
      title: 'Swimming',
      description: 'Enjoy designated swimming areas with lifeguards on duty during summer months. Crystal clear waters.',
      icon: 'ri-water-flash-line',
      color: 'bg-cyan-100 text-cyan-600',
    },
    {
      title: 'Bird Watching',
      description: 'Spot over 100 species of birds. Guided tours available on weekends. Bring your binoculars.',
      icon: 'ri-sparrow-line',
      color: 'bg-sky-100 text-sky-600',
    },
    {
      title: 'Photography',
      description: 'Capture stunning sunrise and sunset views. Photography workshops held monthly for all skill levels.',
      icon: 'ri-camera-line',
      color: 'bg-indigo-100 text-indigo-600',
    },
    {
      title: 'Picnicking',
      description: 'Relax at our scenic picnic areas with tables, grills, and pavilions. Perfect for family gatherings.',
      icon: 'ri-restaurant-line',
      color: 'bg-teal-100 text-teal-600',
    },
    {
      title: 'Camping',
      description: 'Stay overnight at our lakeside campsites. Modern facilities and stunning views. Reservations recommended.',
      icon: 'ri-tent-line',
      color: 'bg-emerald-100 text-emerald-600',
    },
  ];

  return (
    <section id="activities" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Activities & Recreation
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From peaceful relaxation to thrilling adventures, there's something for everyone
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {activities.map((activity, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-sky-50 rounded-lg p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-sky-100 cursor-pointer"
            >
              <div className={`w-14 h-14 ${activity.color} rounded-lg flex items-center justify-center mb-4`}>
                <i className={`${activity.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{activity.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{activity.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-sky-600 to-teal-600 rounded-lg p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-3">Ready for an Adventure?</h3>
          <p className="text-base mb-6 opacity-95">
            Book your activity today and create unforgettable memories at The Way Lake
          </p>
          <button className="bg-white text-sky-600 px-8 py-3 rounded-full text-base font-medium hover:bg-sky-50 transition-colors whitespace-nowrap cursor-pointer">
            Book Now
          </button>
        </div>
      </div>
    </section>
  );
}
